import React from "react";

interface IListIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const ListIcon: React.FC<IListIconProps> = ({ sizeX = 25, sizeY = 24 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.5 6H21.5M8.5 12H21.5M8.5 18H21.5M3.5 6H3.51M3.5 12H3.51M3.5 18H3.51" stroke="#D0BDF8"
                  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}
